import { render, staticRenderFns } from "./DrawerToggle.vue?vue&type=template&id=71a67a4a"
import script from "./DrawerToggle.vue?vue&type=script&lang=js"
export * from "./DrawerToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports